import React, {
	Component
} from 'react';
import { observer } from 'mobx-react';
import FieldSetting from './FieldSetting';
import FormSetting from './FormSetting';
import TemplateEdit from './TemplateEdit';
import FieldSettingEdit from './FieldSettingEdit';

@observer
export default class AddressBookExportSetting extends Component {
	constructor(props) {
        super(props);
    }

	render() {
        return (
            <div>
                <FieldSetting ecId={`${this && this.props && this.props.ecId || ''}_FieldSetting@8iq0xy`} store={this.props.store} />
                <TemplateEdit ecId={`${this && this.props && this.props.ecId || ''}_TemplateEdit@cgi1wj`} store={this.props.store} />
                <FormSetting ecId={`${this && this.props && this.props.ecId || ''}_FormSetting@568a2g`} store={this.props.store} />
                <FieldSettingEdit ecId={`${this && this.props && this.props.ecId || ''}_FieldSettingEdit@h98ivu`} store={this.props.store} />
            </div>
        )
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/resourceExportTemplate/AddressBookExportSetting.js